import { COLORS } from '@btime/constants'
import React from 'react'

import { useAccordionActions, useAccordionState } from './AccordionHandler'
import Center from '../../helpers/Center'
import Icon from '../../shapes/Icon'
import Link from '../../actions/Link'

const AccordionToggler = ({ children, ...props }) => {
  const { open } = useAccordionState()
  const { toggle } = useAccordionActions()
  const icon = 'BsChevron' + (open ? 'Down' : 'Right')

  return (
    <Link onClick={toggle}>
      <Center>
        <Icon name={icon} color={COLORS.dark2} size="1rem" />
      </Center>
    </Link>
  )
}

export default AccordionToggler
